import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import Spin from 'antd/lib/spin';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { selectAccount, selectToken } from '../../../features/auth/ducks';
import { apiCallIds } from '../api';
import {
  selectQuestion,
} from '../ducks'
import { 
fetchQuestionActions,
updateQuestionActions
} from '../ducks';
import { QuestionDetail } from '../components' ;



const mapStateToProps = (state, props) => ({
  question: selectQuestion(state),
  adminAccount: selectAccount(state),
  isLoading: selectIsInProgress(state, apiCallIds.FETCH_QUESTION),
  isAnswering: selectIsInProgress(state, apiCallIds.UPDATE_QUESTION),
  questionId: props.params.questionId,
  token: selectToken(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchQuestion: fetchQuestionActions.request,
      updateQuestion: updateQuestionActions.request
    },
    dispatch
  ),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class QuestionDetailContainer extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    question: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
    adminAccount: PropTypes.object.isRequired,
    isAnswering: PropTypes.bool.isRequired,
    questionId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    token: PropTypes.string.isRequired,
  };

  componentDidMount(){
    const { questionId, actions } = this.props;
    console.log(questionId)
    actions.fetchQuestion( questionId );
  };

  componentDidUpdate(prevProps){
    const { questionId, actions } = this.props;
    if(questionId !== prevProps.questionId){
      actions.fetchQuestion( questionId );
    }
    
  };

  onAnswer = payload => {
    const { questionId, adminAccount, actions } = this.props;
    payload.questionId = questionId
    payload.id_admin = adminAccount.id
    payload.date_answer = new Date().toISOString()
    actions.updateQuestion(payload);
  };

  render(){
    const { question, isLoading, token, t} = this.props

    if(!question){
      return (
        <Spin spinning={isLoading}>
          <div className="spin-empty-content"/>
        </Spin>
      );
    }

    return (
      <Spin spinning={isLoading}>
        <h1>{t('Detail otázky')}</h1>
        <QuestionDetail
          question={question}
          token={token}
          onAnswer={this.onAnswer}
        />
      </Spin>
    )
  }
}


// WEBPACK FOOTER //
// ./src/features/help-management/containers/QuestionDetailContainer.js